import css from './index.module.scss';
import { Box, Button, Flex, Icon, Pane, Text } from '@fullstory/components';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import { useFlags } from '@fullstory/react-hooks';
import { useCurrentTheme } from '@fullstory/theme';
import { intl } from '@fullstory/intl';

export enum SelectorTrimmingState {
  TRIMMING = 1,
  FIXING = 2,
}

interface SelectorTrimmingBannerProps {
  state: SelectorTrimmingState;
  abortTrim: () => void;
}

export const SelectorTrimmingBanner: React.FC<SelectorTrimmingBannerProps> = ({
  state,
  abortTrim,
}) => {
  const flags = useFlags();
  const theme = useCurrentTheme();
  const newFSTAColors = flags.featureFlags().AppNewFstaColors;
  const isDarkMode = theme === 'dark';

  return (
    <div
      data-component="SelectorTrimmingBanner"
      className={css.animation}
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(255,255,255,0.5)',
      }}
    >
      <Box height="100%" width="100%" display="flex" alignItems="flex-end" padding={8}>
        <Pane
          className={newFSTAColors ? css.gradient : css.purple}
          borderRadius={8}
          padding={[16, 12, 16, 12]}
          width="100%"
        >
          <Flex justifyContent="space-between" gap={2}>
            <Flex>
              <Box paddingLeft={8} paddingRight={8}>
                <Icon name="ai-animated" size={16} color="ai" />
              </Box>
              <Text appearance="bodyMediumBold" color="ai">
                {state === SelectorTrimmingState.FIXING
                  ? intl.formatMessage({
                      defaultMessage: 'Fullstory AI is debugging your selector...',
                      id: 'dTiyhb',
                    })
                  : intl.formatMessage({
                      defaultMessage: 'Fullstory AI is fine-tuning your selector...',
                      id: 'PP8pQW',
                    })}
              </Text>
            </Flex>
            <Button
              size="x-small"
              variant={isDarkMode ? 'fill-primary' : 'outline'}
              onClick={abortTrim}
            >
              <FormattedMessage defaultMessage="Cancel" id="47FYwb" />
            </Button>
          </Flex>
        </Pane>
      </Box>
    </div>
  );
};
